export default __webpack_public_path__ + "static/media/Content5.2aaa6baa.png";